import { render } from "./BugReportWidget.vue?vue&type=template&id=3eb646ea&scoped=true"
import script from "./BugReportWidget.vue?vue&type=script&lang=js"
export * from "./BugReportWidget.vue?vue&type=script&lang=js"

import "./BugReportWidget.vue?vue&type=style&index=0&id=3eb646ea&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb646ea"]])

export default __exports__